import { useAdControlsFunctionality } from '@atlassian/jira-adcontrols/button/utils.tsx';

export const useAutoProvisionedOnboardingContentDismissal = (targetProduct: string | undefined) => {
	return useAdControlsFunctionality({
		userPropertyKey: `project-create.show-auto-provisioned-onboarding.${targetProduct}`,
		analytics: {
			panelName: 'project-create-form',
			packageName: '@jira/cross-flow-onboarding-modal',
			teamName: 'galileo',
		},
		fireDefaultEvent: false,
	});
};
